import React, { useState } from "react";
import bigInt from "big-integer";
import Spinner from "./Spinner";

import { useHistory } from "react-router-dom";
import { usePools } from "../hooks/usePools";

import { toFixed } from "../../../constants/constants";

import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import { withStyles } from "@material-ui/core/styles";
import Button from "./Button";
import RewardsMobileCard from "./RewardsMobileCard";
import ConnectWalletButton from "../../connectWalletButton";
import { useAccount } from "../../../contexts/AccountContext";

const styles = (theme) => ({
  root: {
    flex: 1,
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    padding: "30px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      padding: "70px",
    },
    position: "relative",
  },
  goBackContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "auto",

    marginBottom: "8px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "16px",
    },
  },
  goBackIcon: {
    stroke: theme?.colors?.presale?.cardTitle,
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
  goBackBtn: {
    color: theme?.colors?.presale?.cardTitle,
    backgroundColor: "transparent",
    border: "none",
    fontWeight: "600",
    fontSize: "18px",
    cursor: "pointer",

    [theme.breakpoints.up("sm")]: {
      fontSize: "22px",
    },
  },
  rewardsBoardContainer: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "1140px",
  },
  rewardsBoardHeading: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "32px",

    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    [theme.breakpoints.down("675px")]: {
      fontSize: "22px",

      marginBottom: "10px",
    },
  },
  rewardsBoardSubHeading: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    [theme.breakpoints.down("675px")]: {
      fontSize: "14px",
    },
  },
  rewardsBoardSubBold: {
    color: theme?.colors?.presale?.cardTitle,
  },
  rewardsBoardLoader: {
    width: "100%",
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "62px",
  },
  rewardsBoardList: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },

  tableHeader: {
    color: "#A0A0A0",
    fontSize: "14px",
    // background: "#393939",
    background: theme?.colors?.pools?.headerBackground,
    borderBottom: "1px solid " + theme?.colors?.pools?.rowBorderBottom,
    padding: "16px",
  },
  tableBody: {
    background: theme?.colors?.pools?.bodyBackground,
    color: "#fff",
    width: "100%",
  },

  tableRow: {
    borderBottom: "1px solid" + theme?.colors?.pools?.rowBorderBottom,
    color: theme?.colors?.pools?.tableDataText,
  },
  tableRowLast: {
    borderBottom: "none",
    color: theme?.colors?.pools?.tableDataText,
  },
  rewardsBoardTable: {
    width: "100%",
    marginTop: "1.5rem",
    borderCollapse: "collapse",
    borderSpacing: "0",
    boxShadow: "0px 10px 60px " + theme?.colors?.containerShadow,
    borderRadius: "32px",

    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "table",
    },
  },
  rewardsBoardTableHeader: {
    height: "50px",
    borderBottom: "solid 2px " + theme?.colors?.presale?.cardTitle,
  },
  rewardsBoardTableTh: {
    width: "15%",
    padding: "16px",
    fontWeight: "normal",
    textAlign: "left",
  },
  rewardsBoardTableRow: {
    height: "100px",
    borderBottom: "solid 2px " + theme?.colors?.presale?.cardTitle,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  rewardsBoardButtonsContainer: {
    width: "100%",
    display: "flex",
    gap: "16px",
    padding: "16px",
    alignItems: "center",
    justifyContent: "space-around",
  },
  rewardsBoardTableTd: {
    padding: "16px",
    color: theme?.colors?.pools?.tableDataText,
  },
  rewardsBoardTableImgSymbol: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  rewardsBoardTableTdImg: {
    width: "45px",
    marginRight: "10px",
    objectFit: "contain",
  },
  rewardsBoardTableTdText: {},
  rewardsBoardTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: "30px",
    [theme.breakpoints.down("675px")]: {
      flexDirection: "column",
    },
  },

  rewardsBoardTitleLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    [theme.breakpoints.down("675px")]: {
      alignItems: "center",
    },
  },
  rewardsBoardTitleRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    [theme.breakpoints.down("675px")]: {
      alignItems: "center",
    },
  },
  rewardsBoardAddress: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
    marginRight: "50px",
    border: "solid 2px #A0A0A0",
    borderRadius: "20px",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    cursor: "pointer",
    [theme.breakpoints.down("675px")]: {
      marginRight: "0px",
    },
    "&:hover": {
      border: "solid 2px " + theme?.colors?.presale?.cardTitle,
      color: theme?.colors?.presale?.cardTitle,
    },
  },
  connectContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  connectText: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: "600",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    marginBottom: "10px",
  },

  stakingIncomeMobile: {
    width: "100%",
    marginTop: "1.5rem",
    gap: "26px",
    flexDirection: "column",

    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
});

const RewardsBoard = ({ classes }) => {
  const history = useHistory();

  const { items: pools, claim, isLoading } = usePools();
  const [isWaitingTrx, setIsWaitingTrx] = useState(false);

  const { account } = useAccount();

  const onClaimRewards = async (pool) => {
    setIsWaitingTrx(true);
    try {
      await claim(pool);
    } catch (error) {
      console.error("CLAIM ERROR", error);
    }
    setIsWaitingTrx(false);
  };

  return (
    <div className={classes.rewardsBoardContainer}>
      <div className={classes.goBackContainer}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          className={classes.goBackIcon}
          onClick={() => {
            history.goBack();
          }}
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 19.5 8.25 12l7.5-7.5"
          />
        </svg>

        <button
          className={classes.goBackBtn}
          type="button"
          onClick={() => {
            history.goBack();
          }}
        >
          Go back
        </button>
      </div>
      <div className={classes.rewardsBoardTitleContainer}>
        <div className={classes.rewardsBoardTitleLeft}>
          <h1 className={classes.rewardsBoardHeading}>REWARDS</h1>
          <span className={classes.rewardsBoardSubHeading}>
            <span className={classes.rewardsBoardSubBold}>BUIDL</span> rewards
            are subject up to a{" "}
            <span className={classes.rewardsBoardSubBold}>
              12 month vesting period
            </span>{" "}
            at which point they will begin compounding in the BUIDL pool.
            Rewards available for claiming from eligible deposits are listed
            below.
          </span>
        </div>
      </div>
      {isLoading || Object.values(pools).length === 0 ? (
        <div className={classes.rewardsBoardLoader}>
          <Spinner strokeSize="6px" width="54px" height="54px" />
        </div>
      ) : (
        <div className={classes.rewardsBoardList}>
          <div>
            {account ? (
              <>
                <table className={classes.rewardsBoardTable}>
                  <thead className={classes.tableHeader}>
                    <tr>
                      <th
                        style={{
                          padding: "16px",
                          borderTopLeftRadius: "32px",
                          fontWeight: "normal",
                          width: "30%",
                        }}
                      >
                        Pools
                      </th>
                      <th
                        className={classes.rewardsBoardTableTh}
                        style={{ width: "20%" }}
                      >
                        Amount
                      </th>
                      <th
                        className={classes.rewardsBoardTableTh}
                        style={{ width: "20%" }}
                      >
                        Total Deposits
                      </th>
                      <th
                        style={{
                          padding: "16px",
                          borderTopRightRadius: "32px",
                          fontWeight: "normal",
                          width: "30%",
                        }}
                      />
                    </tr>
                  </thead>
                  <tbody className={classes.tableBody}>
                    {Object.values(pools).map((pool, index) => (
                      <tr
                        key={`rewards-${pool.token.address}`}
                        className={
                          index === Object.values(pools).length - 1
                            ? classes.tableRowLast
                            : classes.tableRow
                        }
                      >
                        <td
                          className={classes.rewardsBoardTableTd}
                          style={
                            index === Object.values(pools).length - 1
                              ? {
                                  padding: "16px",
                                  borderBottomLeftRadius: "32px",
                                }
                              : { padding: "16px" }
                          }
                        >
                          <div className={classes.rewardsBoardTableImgSymbol}>
                            <img
                              src={`/tokens/${pool.token.address}.png`}
                              alt="img"
                              className={classes.rewardsBoardTableTdImg}
                            />
                            <span className={classes.rewardsBoardTableTdText}>
                              {pool?.token?.symbol}
                            </span>
                          </div>
                        </td>
                        <td className={classes.rewardsBoardTableTd}>
                          {toFixed(pool?.pending || "0", 18, 2)}
                        </td>
                        <td className={classes.rewardsBoardTableTd}>
                          {pool?.depositLength || 0}
                        </td>
                        <td
                          style={
                            index === Object.values(pools).length - 1
                              ? {
                                  padding: "16px",
                                  borderBottomRightRadius: "32px",
                                }
                              : { padding: "16px" }
                          }
                        >
                          <div className={classes.rewardsBoardButtonsContainer}>
                            {isWaitingTrx ? (
                              <Button
                                classes={{
                                  root: classes.poolButton,
                                  label: classes.buttonLabel,
                                }}
                                disabled
                                onClick={() => {
                                  // TODO: Add wait function
                                }}
                                text="Please Wait..."
                              />
                            ) : (
                              <Button
                                classes={{
                                  root: classes.poolButton,
                                  label: classes.buttonLabel,
                                }}
                                disabled={!bigInt(pool?.pending).greater("0")}
                                onClick={() => {
                                  if (bigInt(pool?.pending).greater("0")) {
                                    onClaimRewards(pool);
                                  }
                                }}
                                text="Claim Rewards"
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className={classes.stakingIncomeMobile}>
                  {Object.values(pools).map((pool, index) => (
                    <RewardsMobileCard
                      pool={pool}
                      isWaitingTrx={isWaitingTrx}
                      onClaimRewards={onClaimRewards}
                    />
                  ))}
                </div>
              </>
            ) : (
              <div className={classes.connectContainer}>
                <div className={classes.connectText}>
                  Connect your wallet to see available pools
                </div>
                <ConnectWalletButton />
              </div>
            )}
          </div>
        </div>
      )}
      {/* todo: OpenModal */}
      {/* <WalletModal
        modalOpen={walletModal}
        onClose={() => {
          showWalletModal(false);
        }}
      /> */}
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(RewardsBoard)));
